




import { Component } from 'vue-property-decorator'
import { mixins } from 'vue-class-component'
import { FilterComponentMixin } from '@/mixins/filter-component.mixin'

@Component
export default class CheckboxFilter extends mixins(FilterComponentMixin) {
  onChange({ target: { checked } }): void {
    this.$set(this.filter, 'value', checked ? checked : null)
  }
}
